// extracted by mini-css-extract-plugin
module.exports = {"cardBox":"status-card_cardBox__IxNUd","statusBox":"status-card_statusBox__29Rwz","statusInfo":"status-card_statusInfo__19Juq"};